import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import wavingKiwi from '../../images/wavingKiwi.png';
import styles from './dropIn.module.css';
import Header from '../../components/UIContainer/MobileUI/header/index';
import { go } from '../../routes/index';
import { isDesktop } from '../../config';
import { ReactComponent as RightArrow } from '../../svgs/rightarrow.svg';
import { actions as feelingActions } from '../Reason/actions/actions';


const DropIn = ({ updateSession, ...props }) => {
    const history = useHistory();

    const practice = props.location.state.practice;

    return (
        <div className={styles.feelingPage}>
            {!isDesktop() && <Header goBackFn={() => history.goBack()} headerClassNames={styles.header} showHelp />}

            <div className={styles.container}>
                <img src={wavingKiwi} className={styles.feelingIcon} alt='No booking required' />
                <div className={styles.labelSmall}>
                    It seems that you do not need an appointment for your chosen service and symptoms. Please drop-in at one of our clinics to be seen.
                </div>
                <div className={styles.labelSmall}>
                    If you are enrolled with us and prefer to make an appointment, please book with your enrolled doctor.
                </div>
            </div>

            {isDesktop() ? (
                <div className={styles.nextContainer}>
                    {/* eslint-disable-next-line */}
                    <a className={styles.navLinkLarge} style={{ visibility: "hidden" }} onClick={() => history.goBack()}>
                        <RightArrow className={styles.backwardArrow} />
                        <span>Back</span>
                    </a>
                    {/* eslint-disable-next-line */}
                    <a className={styles.navLinkLarge} onClick={() => go.practiceProfile(practice.UrlName)}>
                        <span>Book with my doctor</span>
                    </a>
                </div>
            ) : (
                <div className={styles.footer}>
                    {/* eslint-disable-next-line */}
                    <a onClick={() => { go.practiceProfile(practice.UrlName); }}>
                        <div className={styles.back}><u>Book with my doctor</u></div>
                    </a>
                </div>
            )}
        </div>
    )
}

const mapStateToProps = state => ({
    practice: state.practiceProfileReducer.profile
})

const mapDispatchToProps = dispatch => ({
    updateSession: bindActionCreators(feelingActions.updateSession, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DropIn);